import { cloneDeep } from 'lodash'

import { AskResponse, Citation } from '../../api'

export type ParsedAnswer = {
  citations: Citation[]
  markdownFormatText: string
}

export const enumerateCitations = (citations: Citation[]) => {
  const filepathMap = new Map()
  for (const citation of citations) {
    const { url } = citation
    let part_i = 1
    if (filepathMap.has(url)) {
      part_i = filepathMap.get(url) + 1
    }
    filepathMap.set(url, part_i)
    citation.part_index = part_i
  }
  return citations
}

function prepareCitation(citation: Citation, index: number): Citation {
  const refNumber = (index + 1).toString();
  const updatedCitation = cloneDeep(citation);

  updatedCitation.id = refNumber;
  updatedCitation.reindex_id = refNumber;

  if (updatedCitation.chunk_id && !isNaN(Number(updatedCitation.chunk_id))) {
    updatedCitation.chunk_id = (Number(updatedCitation.chunk_id) + 1).toFixed(1);
  }

  return updatedCitation;
}

export function parseAnswer(answer: AskResponse, includeAllCitations = false): ParsedAnswer {
  let answerText = answer.answer;

  answerText = answerText.replace(/\\\[(.*?)\\\]/gs, (_, expr: string) => `$$${expr}$$`);
  answerText = answerText.replace(/\\\((.*?)\\\)/gs, (_, expr: string) => `$${expr}$`);
  answerText = answerText.replace(/\(\$(.*?)\$\)/g, (_, expr: string) => `$${expr}$`);

  const filteredCitations: Citation[] = [];
  const usedReferences = new Set<string>();

  const citationMap = new Map<string, Citation>();
  answer.citations.forEach((citation, index) => {
    const ref = citation.reference;
    if (ref) {
      citationMap.set(ref, prepareCitation(citation, index));
    }
  });

  answerText = answerText.replace(/\[(doc)?(\d+)]/g, (match: string, _docPrefix: string, num: string) => {
    const ref = `[${num}]`;
    const citation = citationMap.get(ref);

    if (citation) {
      if (!usedReferences.has(ref)) {
        filteredCitations.push(citation);
        usedReferences.add(ref);
      }
      return ` ^${num}^ `;
    }

    return match;
  });

  if (includeAllCitations) {
    answer.citations.forEach((citation, index) => {
      const ref = `[${index + 1}]`;
      if (!usedReferences.has(ref)) {
        filteredCitations.push(prepareCitation(citation, index));
        usedReferences.add(ref);
      }
    });
  }

  return {
    citations: filteredCitations,
    markdownFormatText: answerText
  };
}
